import React, { useEffect } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import './ibl.css';

export const BASE = '/iteration-body-labs';
export const DISCORD = 'https://discord.gg/NWwfCrWbGS';
export const MAIL = 'mailto:paul@exitdeath.com?subject=Collaboration%20on%20Iteration%20Body%20Labs';
export const fmtDate = (d) => d.replace(/-/g, '.');

const TITLES = { research: 'Research', log: 'Log' };

export function Wordmark({ className = '' }) {
  return (
    <Link to={BASE} className={`inline-flex items-baseline gap-2 ${className}`} aria-label="Iteration Body Labs, home">
      <span className="text-[19px] font-medium tracking-[-0.03em] leading-none">iteration</span>
      <span className="ibl-mono text-[9px] ibl-muted leading-none whitespace-nowrap">body labs</span>
      <span className="hidden sm:inline ibl-mono text-[11px] ibl-faint leading-none -ml-1" aria-hidden="true">+</span>
    </Link>
  );
}

export default function Layout() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const section = pathname.replace(BASE, '').split('/')[1];
    document.title = TITLES[section] ? `${TITLES[section]} · Iteration Body Labs` : 'Iteration Body Labs — Research collective for human augmentation';
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView();
    else window.scrollTo(0, 0);
  }, [pathname, hash]);

  return (
    <div className="ibl min-h-screen flex flex-col">
      <header className="sticky top-0 z-50 px-4 pt-4 pointer-events-none">
        <nav className="ibl-nav pointer-events-auto mx-auto max-w-6xl flex items-center justify-between gap-4 rounded-full border ibl-line bg-[rgba(236,235,230,0.82)] backdrop-blur-md px-5 py-3">
          <Wordmark />
          <div className="flex items-center gap-5 sm:gap-8 text-[13px] font-medium">
            <NavLink to={`${BASE}/research`}>Research</NavLink>
            <NavLink to={`${BASE}/log`}>Log</NavLink>
            <Link to={`${BASE}#join`}>Join</Link>
            <a href={DISCORD} target="_blank" rel="noopener noreferrer" className="hidden sm:inline">Discord ↗</a>
          </div>
        </nav>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t ibl-line mt-24">
        <div className="mx-auto max-w-6xl px-6 pt-10 pb-8">
          <img src="/iteration-body-labs/iteration-mark.jpg" alt="iteration" className="ibl-mark w-full max-w-3xl mx-auto" loading="lazy" />
          <div className="mt-10 grid gap-6 sm:grid-cols-[1fr_auto] items-end">
            <div className="ibl-mono text-[10px] ibl-faint leading-relaxed">
              © Iteration Body Labs · an <Link to="/projects" className="underline underline-offset-2 hover:text-[var(--ibl-ink)]">Exit Death</Link> project
            </div>
            <div className="flex flex-wrap gap-x-6 gap-y-2 text-[13px] ibl-muted">
              <a href={MAIL} className="hover:text-[var(--ibl-ink)]">paul@exitdeath.com</a>
              <a href={DISCORD} target="_blank" rel="noopener noreferrer" className="hover:text-[var(--ibl-ink)]">Discord ↗</a>
              <Link to={`${BASE}/research`} className="hover:text-[var(--ibl-ink)]">Research</Link>
              <Link to={`${BASE}/log`} className="hover:text-[var(--ibl-ink)]">Log</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
